import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { TrackPage } from './pages/TrackPage';
import { LANGUAGES, detectBrowserLanguage, type SupportedLanguage } from './i18n/uiCopy';

// If the customer arrived from a link in one of our localized emails
// (?lang=pt-BR etc.), honor that exact language on first load; otherwise
// fall back to the browser's own language. This only seeds the initial
// value — once loaded, the in-page language switcher is the single source
// of truth, so it isn't re-derived from the URL on every render.
function initialLanguage(): SupportedLanguage {
  if (typeof window !== 'undefined') {
    const fromQuery = new URLSearchParams(window.location.search).get('lang');
    if (fromQuery && LANGUAGES.some((l) => l.code === fromQuery)) {
      return fromQuery as SupportedLanguage;
    }
  }
  return detectBrowserLanguage();
}

export function App() {
  const [language, setLanguage] = useState<SupportedLanguage>(initialLanguage);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home language={language} setLanguage={setLanguage} />} />
        <Route path="/track/:code" element={<TrackPage language={language} setLanguage={setLanguage} />} />
      </Routes>
    </BrowserRouter>
  );
}
